import { render, staticRenderFns } from "./g-nav-list.vue?vue&type=template&id=7ab3522a&"
import script from "./g-nav-list.vue?vue&type=script&lang=js&"
export * from "./g-nav-list.vue?vue&type=script&lang=js&"
import style0 from "./g-nav-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports